class FrontService {

    compare(a, b) {
        return (a > b) ? -1 : ((b > a) ? 1 : 0);
    }

    compareTime(time1, time2) {
        if (time1 && time2) {
            const aTimeSplit = time1.split(':');
            const bTimeSplit = time2.split(':');
            for (let i = 0; i < aTimeSplit.length; i++) {
                const compareValue = this.compare(aTimeSplit[i], bTimeSplit[i]);
                if (compareValue !== 0) {
                    return compareValue;
                }
            }
        }
        return 0;
    }

    compareDateTime(date1, date2) {
        const aDateSplit = date1.split(' ');
        const bDateSplit = date2.split(' ');
        const dateCompare = this.compareDate(aDateSplit[0].slice(0,-1), bDateSplit[0].slice(0, -1));
        if (dateCompare === 0) {
            return this.compareTime(aDateSplit[1], bDateSplit[1]);
        } else {
            return dateCompare;
        }
    }

    compareDate(date1, date2) {
        const aDateSplit = date1.split('/');
        const bDateSplit = date2.split('/');
        const yearCompare = this.compare(aDateSplit[2], bDateSplit[2]);
        if (yearCompare === 0) {
            const monthCompare = this.compare(aDateSplit[1], bDateSplit[1]);
            if (monthCompare === 0) {
                return this.compare(aDateSplit[0], bDateSplit[0])
            } else {
                return monthCompare;
            }
        } else {
            return yearCompare;
        }
    }

    customSort(dateField, items, index, isDesc) {
        if (items.length <= 1)
            return items;
        items.sort((a, b) => {
            if (index.length > 0 && index[0] === dateField) {
                if (!isDesc[0]) {
                    return this.compareDateTime(a.date, b.date);
                } else {
                    return this.compareDateTime(b.date, a.date);
                }
            } else {
                if (!isDesc[0]) {
                    return a[index].toLowerCase() < b[index].toLowerCase() ? -1 : 1;
                } else {
                    return b[index].toLowerCase() < a[index].toLowerCase() ? -1 : 1;
                }
            }
        });
        return items;
    }

    customSortDateName(dateField, nameField, items, index, isDesc) {
        if (items.length <= 1)
            return items;
        items.sort((a, b) => {
            if (index.length > 0 && index[0] === dateField) {
                if (!isDesc[0]) {
                    return this.compareDateTime(a.date, b.date);
                } else {
                    return this.compareDateTime(b.date, a.date);
                }
            } else {
                if (index.length > 0 && index[1] === nameField) {
                    if (!isDesc[0]) {
                        return a[index].toLowerCase() < b[index].toLowerCase() ? -1 : 1;
                    } else {
                        return b[index].toLowerCase() < a[index].toLowerCase() ? -1 : 1;
                    }
                } else {
                    if (!isDesc[0]) {
                        return a[index] < b[index] ? -1 : 1;
                    } else {
                        return b[index] < a[index] ? -1 : 1;
                    }
                }
            }
        });
        return items;
    }

    geolocationDescription(geolocation) {
        if (geolocation.ville_id) {
            return geolocation.zip_code_id.substring(0, 5) + ' - ' + this.capitalizeFirstLetter(geolocation.name);
        } else if (geolocation.departement_id) {
            return geolocation.departement_id.toLocaleString('fr-FR', {minimumIntegerDigits: 2}) + ' - ' + geolocation.name;
        } else {
            return geolocation.name;
        }
    }

    numberWithSpaces(x: number) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }


}

// A singleton instance
export default new FrontService();
